var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common__config" },
    [
      _c(
        "div",
        { staticClass: "order__title-top" },
        [
          _vm.queryData.title
            ? _c("span", [_vm._v(_vm._s(_vm.queryData.title))])
            : _c("span", [_vm._v("订单规则")]),
          _vm.queryData.order_id
            ? _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    "font-size": "14px",
                    "font-weight": "400",
                  },
                },
                [_vm._v("（ID：" + _vm._s(_vm.queryData.order_id) + "）")]
              )
            : _vm._e(),
          _vm.orderInfo.card_bin_group_id != 7 &&
          _vm.orderInfo.card_bin_group_id != 8 &&
          _vm.orderInfo.copy_order_rule_auth == 1 &&
          _vm.orderInfo.use_type != 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.copyOrderRule },
                },
                [_vm._v("复制订单规则")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.configType != "delivery"
        ? _c("div", { staticClass: "tips_style" }, [
            _c("i", {
              staticClass: "el-icon-info",
              staticStyle: { color: "#e12b1f" },
            }),
            _vm._v(
              " 规则说明：1.该页面为卡类型对应的通用配置，创建订单后默认使用此配置规则。更改通用配置规则后，订单会同步更改；2.若在订单中修改了任何通用配置信息，则不再受通用规则影响。 "
            ),
          ])
        : _vm._e(),
      _vm.isStandardRule && _vm.configType != "delivery"
        ? _c("div", { staticClass: "tips_style" }, [
            _c("i", {
              staticClass: "el-icon-info",
              staticStyle: { color: "#e12b1f" },
            }),
            _vm._v(
              " 当前报价单为【标准卡规则】，功能菜单/基本规则仅查看，交付信息可编辑 "
            ),
          ])
        : _vm._e(),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: {
            "tab-click": function ($event) {
              return _vm.tabChange(_vm.configType)
            },
          },
          model: {
            value: _vm.configType,
            callback: function ($$v) {
              _vm.configType = $$v
            },
            expression: "configType",
          },
        },
        [
          !_vm.onlyDelivery
            ? _c("el-tab-pane", { attrs: { label: "功能菜单", name: "menu" } })
            : _vm._e(),
          !_vm.onlyDelivery
            ? _c("el-tab-pane", { attrs: { label: "基本规则", name: "rule" } })
            : _vm._e(),
          _vm.hasDeliveryAuth
            ? _c("el-tab-pane", {
                attrs: { label: "交付信息", name: "delivery" },
              })
            : _vm._e(),
          _vm.showLogBtn && !_vm.onlyDelivery
            ? _c("el-tab-pane", { attrs: { label: "日志", name: "log" } })
            : _vm._e(),
        ],
        1
      ),
      _vm.cardBinGroupId != 3 && _vm.configType == "rule"
        ? _c("div", { staticClass: "card__rule" }, [
            _c(
              "div",
              { staticClass: "rule__left" },
              [
                _c("div", { staticClass: "title__first" }, [_vm._v("卡规则")]),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.form,
                      "label-width": "150px",
                      disabled: _vm.isStandardRule,
                    },
                  },
                  [
                    _vm.cardBinGroupId != 4
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: "充值权限:", prop: "is_recharge" },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.cardBinGroupId == 6 },
                                model: {
                                  value: _vm.form.is_recharge,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "is_recharge", $$v)
                                  },
                                  expression: "form.is_recharge",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("开启"),
                                ]),
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("关闭"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "卡合并权限:", prop: "is_merge" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.cardBinGroupId == 6 },
                            model: {
                              value: _vm.form.is_merge,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "is_merge", $$v)
                              },
                              expression: "form.is_merge",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("开启"),
                            ]),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.cardBinGroupId != 4
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "合并方式:",
                              prop: "is_type_merge",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: {
                                  disabled:
                                    _vm.cardBinGroupId == 4 ||
                                    _vm.cardBinGroupId == 6,
                                },
                                model: {
                                  value: _vm.form.is_type_merge,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "is_type_merge", $$v)
                                  },
                                  expression: "form.is_type_merge",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("限同类型合并"),
                                ]),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("允许跨类型合并"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.cardBinGroupId != 4
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "是否启用积分价值:",
                              prop: "is_type_merge",
                            },
                          },
                          [
                            _c("span", { staticStyle: { margin: "0 10px" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.integralForm.is_open_integral_value == 0
                                    ? "关闭"
                                    : "开启"
                                )
                              ),
                            ]),
                            !_vm.isStandardRule &&
                            _vm.$hasBtnRoles("/orders/new-card-rule/set-config")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: { click: _vm.openIntegralDialog },
                                  },
                                  [_vm._v("配置")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.cardBinGroupId != 4 &&
                    _vm.form.is_open_integral_value == 1
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "积分价值单位:",
                              prop: "integral_value_unit",
                              rules: [
                                {
                                  required: true,
                                  message: "请输入积分价值单位",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "220px" },
                              attrs: {
                                clearable: "",
                                disabled: "",
                                placeholder: "请输入",
                              },
                              model: {
                                value: _vm.form.integral_value_unit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "integral_value_unit", $$v)
                                },
                                expression: "form.integral_value_unit",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.cardBinGroupId != 4 &&
                    _vm.form.is_open_integral_value == 1
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "积分价值比例:",
                              prop: "integral_value_rate",
                              rules: [
                                {
                                  required: true,
                                  trigger: "blur",
                                  message: "请输入积分价值比例",
                                },
                                {
                                  pattern: /^\d{1,9}(.\d{1,4})?$/,
                                  message: "请填写数字格式，最多四位小数",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                staticStyle: { width: "220px" },
                                attrs: { placeholder: "请输入", disabled: "" },
                                model: {
                                  value: _vm.form.integral_value_rate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "integral_value_rate",
                                      $$v
                                    )
                                  },
                                  expression: "form.integral_value_rate",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                            _c("span", { staticStyle: { color: "#67c23a" } }, [
                              _vm._v(
                                "100点= " +
                                  _vm._s(_vm.toFixedRate) +
                                  _vm._s(
                                    _vm.integralForm.integral_value_unit
                                      ? _vm.integralForm.integral_value_unit
                                      : "积分"
                                  )
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.cardBinGroupId == 4
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "单次支付上限：",
                              prop: "max_goods_points",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "220px" },
                              attrs: { disabled: "", placeholder: "请输入" },
                              model: {
                                value: _vm.form.max_goods_points,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "max_goods_points", $$v)
                                },
                                expression: "form.max_goods_points",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.cardBinGroupId == 4
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "积分价值：",
                              prop: "other_max_goods_points",
                              rules: _vm.otherMaxRule,
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "220px" },
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.form.other_max_goods_points,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "other_max_goods_points",
                                    $$v
                                  )
                                },
                                expression: "form.other_max_goods_points",
                              },
                            }),
                            _c("div", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                " 1.购买非电影类商品，次卡价值等同于积分价值 "
                              ),
                            ]),
                            _c("div", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                " 2.开通非电影类菜单时，积分价值不允许为0 "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.cardBinGroupId != 6 && _vm.cardBinGroupId != 4
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "充值比例：",
                              rules: [
                                { required: true, message: "请输入充值比例" },
                                {
                                  pattern: /^\d{1,9}(.\d{1,2})?$/,
                                  message: "请输入数字格式，仅限两位小数",
                                },
                              ],
                              prop: "recharge_ratio",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "220px" },
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.form.recharge_ratio,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "recharge_ratio", $$v)
                                },
                                expression: "form.recharge_ratio",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户解绑:", prop: "user_unbind" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.user_unbind,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "user_unbind", $$v)
                              },
                              expression: "form.user_unbind",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("开启"),
                            ]),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "卡面展示信息：" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "353px" },
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入内容",
                            maxlength: "300",
                            "show-word-limit": "",
                            autosize: { minRows: 3, maxRows: 10 },
                          },
                          model: {
                            value: _vm.form.card_desc,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "card_desc", $$v)
                            },
                            expression: "form.card_desc",
                          },
                        }),
                        _c("div", { staticStyle: { color: "red" } }, [
                          _vm._v("该内容将在用户卡面上显示,请谨慎修改"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "用户绑卡数上限",
                          prop: "max_bind_num",
                          rules: [
                            {
                              pattern: /^([[0-9]*)$/,
                              message: "请输入正整数！",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "130px" },
                          attrs: {
                            clearable: "",
                            placeholder: "请输入0或正整数",
                          },
                          model: {
                            value: _vm.form.max_bind_num,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "max_bind_num",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.max_bind_num",
                          },
                        }),
                        _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("用于设置同一订单同一用户最多可绑定的卡数"),
                        ]),
                        _c("div", { staticStyle: { color: "red" } }, [
                          _vm._v("输入内容为空或0时，无绑卡数的上限"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "静态码核销条件",
                          prop: "yl88_charge_off_type",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.yl88_charge_off_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "yl88_charge_off_type", $$v)
                              },
                              expression: "form.yl88_charge_off_type",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v("直接核销"),
                            ]),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("绑卡后核销"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "line" }),
            _c(
              "div",
              { staticClass: "rule__right" },
              [
                _c(
                  "el-form",
                  {
                    ref: "numberValidateForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.form,
                      "label-width": "100px",
                      disabled: _vm.isStandardRule,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "背景图：" } },
                      [
                        _c("upload-file", {
                          staticClass: "upload-img",
                          attrs: {
                            "link-url": _vm.linkUrl,
                            tempurl: _vm.img_url,
                            disabled: _vm.isStandardRule,
                          },
                          on: { emitUploadFile: _vm.emitUploadFile },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "说明：", prop: "customer_id" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "353px" },
                          attrs: {
                            type: "textarea",
                            rows: "7",
                            placeholder: "请输入",
                          },
                          model: {
                            value: _vm.form.note,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "note", $$v)
                            },
                            expression: "form.note",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.cardBinGroupId == 3 && _vm.configType == "rule"
        ? _c(
            "div",
            { staticClass: "gift__style" },
            [
              _c("div", { staticClass: "title__first" }, [_vm._v("卡规则")]),
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "gift-ruleForm",
                  attrs: {
                    model: _vm.form,
                    "label-width": "170px",
                    disabled: _vm.isStandardRule,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "充值权限:", prop: "is_recharge" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.is_recharge,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "is_recharge", $$v)
                            },
                            expression: "form.is_recharge",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("开启"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "纯微信支付:",
                        prop: "is_open_all_wx_pay",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.is_open_all_wx_pay,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "is_open_all_wx_pay", $$v)
                            },
                            expression: "form.is_open_all_wx_pay",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("开启"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "微信补差价:", prop: "open_wx_pay" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.open_wx_pay,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "open_wx_pay", $$v)
                            },
                            expression: "form.open_wx_pay",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("开启"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.ruleType == "order"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否支持同方案卡合并:",
                            prop: "is_programme_merge",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.is_programme_merge,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "is_programme_merge", $$v)
                                },
                                expression: "form.is_programme_merge",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不支持"),
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("支持"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.cardBinGroupId != 4
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否启用积分价值:",
                            prop: "is_type_merge",
                          },
                        },
                        [
                          _c("span", { staticStyle: { margin: "0 10px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.integralForm.is_open_integral_value == 0
                                  ? "关闭"
                                  : "开启"
                              )
                            ),
                          ]),
                          _vm.$hasBtnRoles("/orders/new-card-rule/set-config")
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.openIntegralDialog },
                                },
                                [_vm._v("配置 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "充值比例：",
                        rules: [
                          { required: true, message: "请输入充值比例" },
                          {
                            pattern: /^\d{1,9}(.\d{1,2})?$/,
                            message: "请输入数字格式，仅限两位小数",
                          },
                        ],
                        prop: "recharge_ratio",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.recharge_ratio,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "recharge_ratio", $$v)
                          },
                          expression: "form.recharge_ratio",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.cardBinGroupId != 4 &&
                  _vm.form.is_open_integral_value == 1
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: {
                            label: "积分价值单位:",
                            prop: "integral_value_unit",
                            rules: [
                              { required: true, message: "请输入积分价值单位" },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "220px" },
                            attrs: {
                              clearable: "",
                              disabled: "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.integral_value_unit,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "integral_value_unit", $$v)
                              },
                              expression: "form.integral_value_unit",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.cardBinGroupId != 4 &&
                  _vm.form.is_open_integral_value == 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "积分价值比例:",
                            prop: "integral_value_rate",
                            rules: [
                              {
                                required: true,
                                trigger: "blur",
                                message: "请输入积分价值比例",
                              },
                              {
                                pattern: /^\d{1,9}(.\d{1,4})?$/,
                                message: "请填写数字格式，最多四位小数",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "220px" },
                              attrs: { placeholder: "请输入", disabled: "" },
                              model: {
                                value: _vm.form.integral_value_rate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "integral_value_rate", $$v)
                                },
                                expression: "form.integral_value_rate",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                          _c("span", { staticStyle: { color: "#67c23a" } }, [
                            _vm._v(
                              "100点= " +
                                _vm._s(_vm.toFixedRate) +
                                _vm._s(
                                  _vm.integralForm.integral_value_unit
                                    ? _vm.integralForm.integral_value_unit
                                    : "积分"
                                )
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户解绑:", prop: "user_unbind" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.user_unbind,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "user_unbind", $$v)
                            },
                            expression: "form.user_unbind",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("开启"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "背景图：" } },
                    [
                      _c("upload-file", {
                        attrs: {
                          "link-url": _vm.linkUrl,
                          tempurl: _vm.img_url,
                        },
                        on: { emitUploadFile: _vm.emitUploadFile },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { label: "余额展示:", prop: "is_recharge" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: _vm.ruleType == "cardType",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.form.package_view_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "package_view_type", $$v)
                            },
                            expression: "form.package_view_type",
                          },
                        },
                        _vm._l(_vm.package_views, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.package_view_type == 1 && _vm.ruleType != "cardType"
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: {
                            label: "单次面值",
                            prop: "single_face",
                            rules: [
                              { required: true, message: "请填写单次面值" },
                              {
                                pattern: /^([0-9]*)$/,
                                message: "请填写单次面值，仅限正整数",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "220px" },
                            attrs: { placeholder: "请输入正整数" },
                            model: {
                              value: _vm.form.single_face,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "single_face", $$v)
                              },
                              expression: "form.single_face",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: {
                        label: "自选商城名称：",
                        prop: "optional_mall_name",
                        rules: [
                          { required: true, message: "请输入自组礼包名称" },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.optional_mall_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "optional_mall_name", $$v)
                          },
                          expression: "form.optional_mall_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.ruleType == "order"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "非常规礼包佣金：",
                            prop: "optional_mall_commision",
                            rules: [
                              {
                                required: true,
                                message: "请输入非常规礼包佣金",
                              },
                              {
                                pattern: /^\d{1,9}(.\d{1,2})?$/,
                                message: "请输入非常规礼包佣金，仅限两位小数",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticStyle: {
                                width: "220px",
                                "margin-bottom": "10px",
                              },
                              attrs: { placeholder: "请输入" },
                              model: {
                                value: _vm.form.optional_mall_commision,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "optional_mall_commision",
                                    $$v
                                  )
                                },
                                expression: "form.optional_mall_commision",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(
                              " 填写范围>=0，根据该配置计算非常规礼包佣金比例，已达成订单修改不生效 "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "卡面展示信息：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "353px" },
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入内容",
                          maxlength: "300",
                          "show-word-limit": "",
                          autosize: { minRows: 3, maxRows: 10 },
                        },
                        model: {
                          value: _vm.form.card_desc,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "card_desc", $$v)
                          },
                          expression: "form.card_desc",
                        },
                      }),
                      _c("div", { staticStyle: { color: "red" } }, [
                        _vm._v("该内容将在用户卡面上显示,请谨慎修改"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "用户绑卡数上限",
                        prop: "max_bind_num",
                        rules: [
                          { pattern: /^([[0-9]*)$/, message: "请输入正整数！" },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "130px" },
                        attrs: {
                          clearable: "",
                          placeholder: "请输入0或正整数",
                        },
                        model: {
                          value: _vm.form.max_bind_num,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "max_bind_num",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.max_bind_num",
                        },
                      }),
                      _c("span", { staticStyle: { color: "#ccc" } }, [
                        _vm._v("用于设置同一订单同一用户最多可绑定的卡数"),
                      ]),
                      _c("div", { staticStyle: { color: "red" } }, [
                        _vm._v("输入内容为空或0时，无绑卡数的上限"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "静态码核销条件",
                        prop: "yl88_charge_off_type",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.yl88_charge_off_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "yl88_charge_off_type", $$v)
                            },
                            expression: "form.yl88_charge_off_type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("直接核销"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("绑卡后核销"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.configType == "menu"
        ? _c("div", [
            _vm.cardBinGroupId == 3 && _vm.gift_menus.length
              ? _c(
                  "div",
                  { staticClass: "menu" },
                  [
                    _vm._m(0),
                    _c(
                      "el-table",
                      {
                        staticClass: "menu__form",
                        attrs: {
                          data: _vm.gift_menus,
                          border: "",
                          "header-cell-style": {
                            color: "#333333",
                            background: "#f1f1f1",
                          },
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "custom_cats", label: "类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.type == 1
                                            ? "自组礼包"
                                            : "自选商城"
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2963021293
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "custom_cats", label: "排序" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(scope.$index + 1) + " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3056706777
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "名称" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "category_name", label: "菜单名称" },
                        }),
                        _vm.isShowIntegral
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "is_integral_value",
                                label: "积分价值",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm.canEditRule
                                          ? _c(
                                              "el-button",
                                              {
                                                style: {
                                                  color:
                                                    scope.row
                                                      .is_integral_value == 1
                                                      ? "red"
                                                      : "",
                                                },
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.menuChangeIntegral(
                                                      scope.row,
                                                      "self",
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row
                                                      .is_integral_value == 1
                                                      ? "是"
                                                      : "否"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.is_integral_value ==
                                                    1
                                                    ? "是"
                                                    : "否"
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3802798321
                              ),
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "menu" },
              [
                _c(
                  "div",
                  {
                    staticClass: "title",
                    staticStyle: {
                      "padding-top": "0",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("span", [_vm._v("功能菜单")]),
                    _vm.canEditRule
                      ? _c("span", {
                          staticClass: "add el-icon-circle-plus-outline",
                          on: { click: _vm.openMenuDialog },
                        })
                      : _vm._e(),
                    _vm.canEditRule &&
                    _vm.isShowIntegral &&
                    _vm.cardBinGroupId != 4 &&
                    _vm.$hasBtnRoles("/orders/new-card-rule/set-config")
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.setIntegralValue(1)
                              },
                            },
                          },
                          [_vm._v("一键设置积分价值")]
                        )
                      : _vm._e(),
                    _vm.canEditRule &&
                    _vm.isShowIntegral &&
                    _vm.cardBinGroupId != 4 &&
                    _vm.$hasBtnRoles("/orders/new-card-rule/set-config")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.setIntegralValue(0)
                              },
                            },
                          },
                          [_vm._v("一键取消积分价值")]
                        )
                      : _vm._e(),
                    _vm.ruleInfo.card_bin_group_id == 3 &&
                    _vm.ruleInfo.programme_info &&
                    _vm.ruleInfo.programme_info.premium_price > 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "red",
                              "margin-left": "10px",
                            },
                          },
                          [
                            _vm._v(
                              "方案存在溢价请核实【服务成本】再进行配置！！！"
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    staticClass: "menu__form",
                    attrs: {
                      data: _vm.menuList,
                      border: "",
                      "row-key": "id",
                      "default-expand-all": true,
                      "tree-props": { children: "sub_categorys" },
                      "header-cell-style": {
                        color: "#333333",
                        background: "#f1f1f1",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "group_type_text",
                        width: "90",
                        label: "类型",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "id", width: "65px", label: "菜单ID" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "category_name", label: "标准菜单" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " + _vm._s(scope.row.category_name) + " "
                                ),
                                scope.row.status == 1
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("（隐藏）")]
                                    )
                                  : _vm._e(),
                                scope.row.is_delete == 1
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("（无效）")]
                                    )
                                  : _vm._e(),
                                scope.row.is_nu_standard == 1
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "warning",
                                        },
                                      },
                                      [_vm._v("非标")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4158897616
                      ),
                    }),
                    _vm.isShowIntegral && _vm.cardBinGroupId != 4
                      ? _c("el-table-column", {
                          attrs: {
                            width: "80",
                            prop: "is_integral_value",
                            label: "积分价值",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.canEditRule &&
                                    (scope.row.parentId ||
                                      scope.row.group_type == 1)
                                      ? _c(
                                          "el-button",
                                          {
                                            style: {
                                              color:
                                                scope.row.is_integral_value == 1
                                                  ? "red"
                                                  : "",
                                            },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.menuChangeIntegral(
                                                  scope.row,
                                                  "common",
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.is_integral_value == 1
                                                  ? "是"
                                                  : "否"
                                              )
                                            ),
                                          ]
                                        )
                                      : scope.row.parentId ||
                                        scope.row.group_type == 1
                                      ? _c(
                                          "span",
                                          {
                                            style: {
                                              color:
                                                scope.row.is_integral_value == 1
                                                  ? "red"
                                                  : "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.is_integral_value == 1
                                                  ? "是"
                                                  : "否"
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            665022146
                          ),
                        })
                      : _vm._e(),
                    _vm.ruleType == "order"
                      ? _c("el-table-column", {
                          attrs: { label: "商城显示名称" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        !scope.row.isEdit
                                          ? _c("div", [
                                              _vm._v(
                                                _vm._s(scope.row.alias_name)
                                              ),
                                            ])
                                          : _vm._e(),
                                        scope.row.isEdit
                                          ? _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入内容",
                                                maxlength: "200",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.saveAliasName(
                                                    scope.row
                                                  )
                                                },
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.saveAliasName(
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.alias_name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "alias_name",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.alias_name",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.canEditRule &&
                                        !scope.row.isEdit &&
                                        !scope.row.isChild &&
                                        !scope.row.parentId
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    scope.row.isEdit = true
                                                  },
                                                },
                                              },
                                              [_vm._v("修改")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2378409796
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: {
                        prop: "type_name",
                        width: "80px",
                        label: "业务类型",
                      },
                    }),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "is_show",
                          width: "85px",
                          label: "分类页",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !scope.row.parentId && _vm.canEditRule
                                    ? _c(
                                        "el-button",
                                        {
                                          style: {
                                            color:
                                              scope.row.is_show == 1
                                                ? ""
                                                : "red",
                                          },
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openMenuSwitchDialog(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.is_show == 1
                                                ? "显示"
                                                : "隐藏"
                                            )
                                          ),
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.is_show == 1
                                              ? "显示"
                                              : "隐藏"
                                          )
                                        ),
                                      ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2020367751
                        ),
                      },
                      [
                        _c(
                          "template",
                          { slot: "header" },
                          [
                            _c("span", [_vm._v("分类页")]),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "控制此菜单在分类页的显示和隐藏",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning-outline",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                    _c("el-table-column", {
                      attrs: { prop: "custom_cats", label: "子菜单" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return _vm._l(
                                scope.row.childrens,
                                function (item) {
                                  return _c(
                                    "span",
                                    {
                                      key: item.id,
                                      style: !item.selected ? "color:red" : "",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.custom_cat_name) + " "
                                      ),
                                      item.status == 1
                                        ? _c(
                                            "span",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("（隐藏）")]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              )
                            },
                          },
                        ],
                        null,
                        false,
                        3814803266
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.canEditRule
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delMenu(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("移除")]
                                    )
                                  : _vm._e(),
                                _vm.canEditRule &&
                                scope.row.group_type == 2 &&
                                scope.row.sub_categorys_count >
                                  scope.row.sub_categorys.length
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openGroupMenusDialog(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("添加子菜单")]
                                    )
                                  : _vm._e(),
                                scope.row.group_type != 2
                                  ? [
                                      (scope.row.type == "new_entity" ||
                                        scope.row.type == "entity" ||
                                        scope.row.type == "yanchu" ||
                                        scope.row.type == "vipcard" ||
                                        scope.row.type == "code") &&
                                      _vm.canEditRule
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setChildMenu(
                                                    scope.row.childrens,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("设置子菜单")]
                                          )
                                        : _vm._e(),
                                      [
                                        "mt_daodian",
                                        "mt_waimai",
                                        "ding_d",
                                        "yong_h",
                                        "sam",
                                        "xxcs",
                                      ].includes(scope.row.type)
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openWhiteCity(
                                                    1,
                                                    scope.row.type,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("城市黑名单")]
                                          )
                                        : _vm._e(),
                                      scope.row.relation_type == 4 &&
                                      scope.row.realtion_ids == 1413
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openMovieZydDialog(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("品牌黑名单")]
                                          )
                                        : _vm._e(),
                                      [
                                        "cake_store",
                                        "cake",
                                        "movie",
                                        "lvmama",
                                        "online_order",
                                      ].includes(scope.row.type)
                                        ? [
                                            _vm.$hasBtnRoles(
                                              "/orders/cardrule/set"
                                            ) && _vm.canEditRule
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openCommonMenuDialog(
                                                          scope.row,
                                                          "set"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 设置 ")]
                                                )
                                              : _vm._e(),
                                            _vm.$hasBtnRoles(
                                              "/orders/cardrule/set-detail"
                                            )
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openCommonMenuDialog(
                                                          scope.row,
                                                          "view"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 资源明细 ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                                (scope.row.type == "new_entity" ||
                                  scope.row.type == "entity") &&
                                _vm.$hasBtnRoles("/orders/mall-check/index")
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openGoodsVisibility(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("商品可见性校验")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3185422636
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "menu" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", [_vm._v("特殊品牌 [该配置仅实体、电子码菜单生效]")]),
                _vm.canEditRule
                  ? _c("span", {
                      staticClass: "add el-icon-circle-plus-outline",
                      on: {
                        click: function ($event) {
                          return _vm.openBrandDialog("1")
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "menu__wrap" },
                _vm._l(_vm.checkedSpecialBrands, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "menu__item" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "item__btn",
                          attrs: { type: "info", size: "small", plain: "" },
                        },
                        [
                          _vm._v(" " + _vm._s(item.brand_name) + " "),
                          _vm.canEditRule
                            ? _c("span", {
                                staticClass: "btn-icon el-icon-close",
                                on: {
                                  click: function ($event) {
                                    return _vm.delBrandTag(index)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
            _vm.cardBinGroupId !== 4
              ? _c("div", { staticClass: "menu" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [
                      _vm._v("不支持的供应商 [该配置仅实体、电子码菜单生效]"),
                    ]),
                    _vm.canEditRule
                      ? _c("span", {
                          staticClass: "add el-icon-circle-plus-outline",
                          on: { click: _vm.openSupplierDialog },
                        })
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "menu__wrap" },
                    _vm._l(_vm.checkedSupplier, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "menu__item" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "item__btn",
                              attrs: { type: "info", size: "small", plain: "" },
                            },
                            [
                              _vm._v(" " + _vm._s(item.name) + " "),
                              _vm.canEditRule
                                ? _c("span", {
                                    staticClass: "btn-icon el-icon-close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.delCheckedBox(index)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm.cardBinGroupId !== 4
              ? _c("div", { staticClass: "menu" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [
                      _vm._v("不支持的品牌 [该配置仅实体、电子码菜单生效]"),
                    ]),
                    _vm.canEditRule
                      ? _c("span", {
                          staticClass: "add el-icon-circle-plus-outline",
                          on: {
                            click: function ($event) {
                              return _vm.openBrandDialog("2")
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "menu__wrap" },
                    _vm._l(_vm.checkedNotBrands, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "menu__item" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "item__btn",
                              attrs: { type: "info", size: "small", plain: "" },
                            },
                            [
                              _vm._v(" " + _vm._s(item.name) + " "),
                              _vm.canEditRule
                                ? _c("span", {
                                    staticClass: "btn-icon el-icon-close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.delNotBrand(index)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "menu" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", [
                  _vm._v("标签黑名单 [该配置仅实体、电子码菜单生效]"),
                ]),
                _vm.canEditRule
                  ? _c("span", {
                      staticClass: "add el-icon-circle-plus-outline",
                      on: { click: _vm.openTagDialog },
                    })
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "menu__wrap" },
                _vm._l(_vm.notTags, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "menu__item" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "item__btn",
                          attrs: { type: "info", size: "small", plain: "" },
                        },
                        [
                          _vm._v(" " + _vm._s(item.name) + " "),
                          _vm.canEditRule
                            ? _c("span", {
                                staticClass: "btn-icon el-icon-close",
                                on: {
                                  click: function ($event) {
                                    return _vm.delNotTag(index)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm.configType == "delivery"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.deliveryLoading,
                  expression: "deliveryLoading",
                },
              ],
            },
            [
              _c("delivery-info-form", {
                attrs: {
                  editable: _vm.hasDeliveryAuth,
                  "show-confirm": _vm.hasDeliveryAuth,
                  "confirm-loading": _vm.deliverySaving,
                },
                on: { confirm: _vm.saveDeliveryInfo },
                model: {
                  value: _vm.deliveryForm,
                  callback: function ($$v) {
                    _vm.deliveryForm = $$v
                  },
                  expression: "deliveryForm",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.configType == "log"
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  attrs: {
                    border: "",
                    height: "70vh",
                    data: _vm.logTableData,
                    "header-cell-style": {
                      color: "#333333",
                      background: "#f1f1f1",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "username",
                      label: "修改人",
                      width: "100px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "des",
                      label: "修改内容",
                      "min-width": "300px",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c("div", {
                              domProps: { innerHTML: _vm._s(scope.row.des) },
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      2190130528
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "created_at",
                      label: "修改时间",
                      width: "180px",
                      formatter: function (row) {
                        return _vm.parseTime(row.created_at)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right", "margin-top": "10px" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, prev, pager, next",
                      "current-page": _vm.logPage.page,
                      "page-size": _vm.logPage.page_size,
                      total: _vm.logPage.totalCount,
                    },
                    on: { "current-change": _vm.viewLog },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.whiteCityTitle,
            visible: _vm.whiteCityDialog,
            "append-to-body": "",
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.whiteCityDialog = $event
            },
          },
        },
        [
          !["viewCakeWhite", "viewFoodCity"].includes(_vm.whiteCityType)
            ? [
                _c("span", [_vm._v("选择城市")]),
                _c("el-cascader", {
                  key: _vm.time,
                  attrs: {
                    options: _vm.tempCity,
                    props: {
                      checkStrictly: true,
                      emitPath: true,
                      multiple: true,
                    },
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.city,
                    callback: function ($$v) {
                      _vm.city = $$v
                    },
                    expression: "city",
                  },
                }),
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: !_vm.canEditRule,
                      size: "mini",
                      type: "primary",
                    },
                    on: { click: _vm.addCheckedCity },
                  },
                  [_vm._v("添加")]
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "red",
                      margin: "10px 20px",
                      "font-size": "16px",
                    },
                  },
                  [_vm._v("添加或移除后该规则直接生效！")]
                ),
              ]
            : _vm._e(),
          _c(
            "el-table",
            {
              attrs: {
                border: "",
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                align: "center",
                height: "350",
                "empty-text": "暂未配置" + _vm.whiteCityTitle,
                data: _vm.checkedCityList,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "省份",
                  width: "120px",
                  "show-overflow-tooltip": "",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              scope.row.province ? scope.row.province : "--"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "城市",
                  width: "120px",
                  "show-overflow-tooltip": "",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.city ? scope.row.city : "--")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.whiteCityType == "movie"
                ? _c("el-table-column", {
                    attrs: {
                      label: "区县",
                      width: "120px",
                      "show-overflow-tooltip": "",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(scope.row.town ? scope.row.town : "--")
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2862594292
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              disabled:
                                ["viewCakeWhite", "viewFoodCity"].includes(
                                  _vm.whiteCityType
                                ) || !_vm.canEditRule,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.delCheckedCity(scope.row.code)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "right",
                "margin-top": "10px",
                "padding-bottom": "10px",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next",
                  "page-size": 20,
                  total: _vm.pages.totalCount,
                },
                on: {
                  "current-change": function (res) {
                    return _vm.onChange(res, 5)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c("up-load-file-dialog", {
        ref: "myUploadchild",
        attrs: {
          "upload-filed-dialog-show": _vm.uploadFiledDialogShow,
          "dialog-file-title": _vm.dialogFileTitle,
          "demo-title": _vm.demoTitle,
          "up-title": _vm.upTitle,
          "tips-title": _vm.tipsTitle,
          appendToBody: true,
        },
        on: {
          emitUpload: _vm.emitUpload,
          emitErrorFile: _vm.emitErrorFile,
          emitDownDemo: _vm.emitDownDemo,
          emitSaveFile: _vm.emitSaveFile,
        },
      }),
      _c(
        "el-drawer",
        {
          staticClass: "menu__drawer",
          attrs: {
            title: "功能菜单",
            visible: _vm.menuDialog,
            "with-header": false,
            size: "88%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.menuDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "menuDrawer" }, [
            _c("div", { staticClass: "drawer-title-box" }, [
              _c("span", { staticClass: "title" }, [_vm._v("功能菜单")]),
              _c(
                "span",
                {
                  staticClass: "close",
                  on: {
                    click: function ($event) {
                      _vm.menuDialog = false
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-close" })]
              ),
            ]),
            _c("div", { staticClass: "drawer-content-box" }, [
              _c("div", { staticClass: "drawer-content" }, [
                _c(
                  "div",
                  { staticClass: "topBox" },
                  [
                    _c("div", { staticClass: "title" }, [_vm._v("已选菜单")]),
                    _c(
                      "el-row",
                      { staticClass: "selectBox" },
                      _vm._l(_vm.selectedMenu, function (item, index) {
                        return _c(
                          "el-col",
                          { key: "sel_" + index, attrs: { span: 8 } },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "tag",
                                attrs: {
                                  closable: "",
                                  type: "info",
                                  color: "#F1F2F5",
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.selectMenu(item, 1)
                                  },
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.id))]),
                                item.category_name.length > 20
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            item.category_name +
                                            (item.note ? "：" + item.note : ""),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              item.category_name.slice(0, 20)
                                            ) + "..."
                                          ),
                                        ]),
                                        item.status == 1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#df0a0a",
                                                },
                                              },
                                              [_vm._v("(隐藏)")]
                                            )
                                          : _vm._e(),
                                        item.use_range == 1
                                          ? _c(
                                              "span",
                                              { staticClass: "tagType1" },
                                              [_vm._v("通")]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "tagType2" },
                                              [_vm._v("专")]
                                            ),
                                      ]
                                    )
                                  : item.category_name.length < 21 && item.note
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            item.category_name +
                                            (item.note ? "：" + item.note : ""),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(item.category_name)),
                                        ]),
                                        item.status == 1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#df0a0a",
                                                },
                                              },
                                              [_vm._v("(隐藏)")]
                                            )
                                          : _vm._e(),
                                        item.use_range == 1
                                          ? _c(
                                              "span",
                                              { staticClass: "tagType1" },
                                              [_vm._v("通")]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "tagType2" },
                                              [_vm._v("专")]
                                            ),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(item.category_name)),
                                    ]),
                                item.status == 1
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#df0a0a" } },
                                      [_vm._v("(隐藏)")]
                                    )
                                  : _vm._e(),
                                item.use_range == 1
                                  ? _c("span", { staticClass: "tagType1" }, [
                                      _vm._v("通"),
                                    ])
                                  : _c("span", { staticClass: "tagType2" }, [
                                      _vm._v("专"),
                                    ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "bottomBox" },
                  [
                    _c("div", { staticClass: "title" }, [_vm._v("备选菜单")]),
                    _c(
                      "div",
                      {
                        staticClass: "formBox",
                        staticStyle: { "padding-left": "10px", color: "#333" },
                      },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "菜单名称：" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.menuForm.category_name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.menuForm,
                                        "category_name",
                                        $$v
                                      )
                                    },
                                    expression: "menuForm.category_name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "菜单别名：" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.menuForm.category_alias_name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.menuForm,
                                        "category_alias_name",
                                        $$v
                                      )
                                    },
                                    expression: "menuForm.category_alias_name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "菜单ID：" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.menuForm.id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.menuForm, "id", $$v)
                                    },
                                    expression: "menuForm.id",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.searchMenuList },
                              },
                              [_vm._v("搜索")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.platform_menu.length
                      ? _c("div", [
                          _c("div", { staticClass: "title" }, [
                            _c("span", { staticClass: "titleLine" }),
                            _c("span", [_vm._v("平台菜单")]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "menu__wrap2" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: { change: _vm.onMenuCheckChange },
                                      model: {
                                        value: _vm.checkedMenuIds,
                                        callback: function ($$v) {
                                          _vm.checkedMenuIds = $$v
                                        },
                                        expression: "checkedMenuIds",
                                      },
                                    },
                                    _vm._l(
                                      _vm.platform_menu,
                                      function (item, index) {
                                        return _c(
                                          "el-col",
                                          {
                                            key: "plat_" + index,
                                            attrs: { span: 8 },
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                staticClass: "checkbox-item",
                                                attrs: { label: item.id },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(item.id)),
                                                ]),
                                                item.category_name.length > 20
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            item.category_name +
                                                            (item.note
                                                              ? "：" + item.note
                                                              : ""),
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.category_name.slice(
                                                                0,
                                                                20
                                                              )
                                                            ) + "..."
                                                          ),
                                                        ]),
                                                        item.status == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#df0a0a",
                                                                },
                                                              },
                                                              [_vm._v("(隐藏)")]
                                                            )
                                                          : _vm._e(),
                                                        item.use_range == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType1",
                                                              },
                                                              [_vm._v("通")]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType2",
                                                              },
                                                              [_vm._v("专")]
                                                            ),
                                                      ]
                                                    )
                                                  : item.category_name.length <
                                                      21 && item.note
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            item.category_name +
                                                            (item.note
                                                              ? "：" + item.note
                                                              : ""),
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.category_name
                                                            )
                                                          ),
                                                        ]),
                                                        item.status == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#df0a0a",
                                                                },
                                                              },
                                                              [_vm._v("(隐藏)")]
                                                            )
                                                          : _vm._e(),
                                                        item.use_range == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType1",
                                                              },
                                                              [_vm._v("通")]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType2",
                                                              },
                                                              [_vm._v("专")]
                                                            ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.category_name
                                                        )
                                                      ),
                                                    ]),
                                                item.status == 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#df0a0a",
                                                        },
                                                      },
                                                      [_vm._v("(隐藏)")]
                                                    )
                                                  : _vm._e(),
                                                item.use_range == 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "tagType1",
                                                      },
                                                      [_vm._v("通")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass: "tagType2",
                                                      },
                                                      [_vm._v("专")]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.channel_special.length
                      ? _c("div", [
                          _c("div", { staticClass: "title" }, [
                            _c("span", { staticClass: "titleLine" }),
                            _c("span", [_vm._v("客户专用菜单")]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "menu__wrap2" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: { change: _vm.onMenuCheckChange },
                                      model: {
                                        value: _vm.checkedMenuIds,
                                        callback: function ($$v) {
                                          _vm.checkedMenuIds = $$v
                                        },
                                        expression: "checkedMenuIds",
                                      },
                                    },
                                    _vm._l(
                                      _vm.channel_special,
                                      function (item, index) {
                                        return _c(
                                          "el-col",
                                          {
                                            key: "special_" + index,
                                            attrs: { span: 8 },
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                staticClass: "checkbox-item",
                                                attrs: { label: item.id },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(item.id)),
                                                ]),
                                                item.category_name.length > 20
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            item.category_name +
                                                            (item.note
                                                              ? "：" + item.note
                                                              : ""),
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.category_name.slice(
                                                                0,
                                                                20
                                                              )
                                                            ) + "..."
                                                          ),
                                                        ]),
                                                        item.status == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#df0a0a",
                                                                },
                                                              },
                                                              [_vm._v("(隐藏)")]
                                                            )
                                                          : _vm._e(),
                                                        item.use_range == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType1",
                                                              },
                                                              [_vm._v("通")]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType2",
                                                              },
                                                              [_vm._v("专")]
                                                            ),
                                                      ]
                                                    )
                                                  : item.category_name.length <
                                                      21 && item.note
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            item.category_name +
                                                            (item.note
                                                              ? "：" + item.note
                                                              : ""),
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.category_name
                                                            )
                                                          ),
                                                        ]),
                                                        item.status == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#df0a0a",
                                                                },
                                                              },
                                                              [_vm._v("(隐藏)")]
                                                            )
                                                          : _vm._e(),
                                                        item.use_range == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType1",
                                                              },
                                                              [_vm._v("通")]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType2",
                                                              },
                                                              [_vm._v("专")]
                                                            ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.category_name
                                                        )
                                                      ),
                                                    ]),
                                                item.status == 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#df0a0a",
                                                        },
                                                      },
                                                      [_vm._v("(隐藏)")]
                                                    )
                                                  : _vm._e(),
                                                item.use_range == 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "tagType1",
                                                      },
                                                      [_vm._v("通")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass: "tagType2",
                                                      },
                                                      [_vm._v("专")]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.channel_common.length
                      ? _c("div", [
                          _c("div", { staticClass: "title" }, [
                            _c("span", { staticClass: "titleLine" }),
                            _c("span", [_vm._v("客户通用菜单")]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "menu__wrap2" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: { change: _vm.onMenuCheckChange },
                                      model: {
                                        value: _vm.checkedMenuIds,
                                        callback: function ($$v) {
                                          _vm.checkedMenuIds = $$v
                                        },
                                        expression: "checkedMenuIds",
                                      },
                                    },
                                    _vm._l(
                                      _vm.channel_common,
                                      function (item, index) {
                                        return _c(
                                          "el-col",
                                          {
                                            key: "common_" + index,
                                            attrs: { span: 8 },
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                staticClass: "checkbox-item",
                                                attrs: { label: item.id },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(item.id)),
                                                ]),
                                                item.category_name.length > 20
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            item.category_name +
                                                            (item.note
                                                              ? "：" + item.note
                                                              : ""),
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.category_name.slice(
                                                                0,
                                                                20
                                                              )
                                                            ) + "..."
                                                          ),
                                                        ]),
                                                        item.status == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#df0a0a",
                                                                },
                                                              },
                                                              [_vm._v("(隐藏)")]
                                                            )
                                                          : _vm._e(),
                                                        item.use_range == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType1",
                                                              },
                                                              [_vm._v("通")]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType2",
                                                              },
                                                              [_vm._v("专")]
                                                            ),
                                                      ]
                                                    )
                                                  : item.category_name.length <
                                                      21 && item.note
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          effect: "dark",
                                                          content:
                                                            item.category_name +
                                                            (item.note
                                                              ? "：" + item.note
                                                              : ""),
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.category_name
                                                            )
                                                          ),
                                                        ]),
                                                        item.status == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#df0a0a",
                                                                },
                                                              },
                                                              [_vm._v("(隐藏)")]
                                                            )
                                                          : _vm._e(),
                                                        item.use_range == 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType1",
                                                              },
                                                              [_vm._v("通")]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType2",
                                                              },
                                                              [_vm._v("专")]
                                                            ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.category_name
                                                        )
                                                      ),
                                                    ]),
                                                item.status == 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#df0a0a",
                                                        },
                                                      },
                                                      [_vm._v("(隐藏)")]
                                                    )
                                                  : _vm._e(),
                                                item.use_range == 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "tagType1",
                                                      },
                                                      [_vm._v("通")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass: "tagType2",
                                                      },
                                                      [_vm._v("专")]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._l(
                      [
                        {
                          title: "客户专用促销菜单",
                          items: _vm.promotion_special,
                          key: "promotion_special",
                        },
                        {
                          title: "客户通用促销菜单",
                          items: _vm.promotion_general,
                          key: "promotion_general",
                        },
                      ],
                      function (promotionMenu) {
                        return promotionMenu.items.length
                          ? _c("div", { key: promotionMenu.key }, [
                              _c("div", { staticClass: "title" }, [
                                _c("span", { staticClass: "titleLine" }),
                                _c("span", [
                                  _vm._v(_vm._s(promotionMenu.title)),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "menu__wrap2" },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          on: { change: _vm.onMenuCheckChange },
                                          model: {
                                            value: _vm.checkedMenuIds,
                                            callback: function ($$v) {
                                              _vm.checkedMenuIds = $$v
                                            },
                                            expression: "checkedMenuIds",
                                          },
                                        },
                                        _vm._l(
                                          promotionMenu.items,
                                          function (item, index) {
                                            return _c(
                                              "el-col",
                                              {
                                                key:
                                                  promotionMenu.key +
                                                  "_" +
                                                  index,
                                                attrs: { span: 8 },
                                              },
                                              [
                                                _c(
                                                  "el-checkbox",
                                                  {
                                                    staticClass:
                                                      "checkbox-item",
                                                    attrs: { label: item.id },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(_vm._s(item.id)),
                                                    ]),
                                                    item.category_name.length >
                                                    20
                                                      ? _c(
                                                          "el-tooltip",
                                                          {
                                                            staticClass: "item",
                                                            attrs: {
                                                              effect: "dark",
                                                              content:
                                                                item.category_name +
                                                                (item.note
                                                                  ? "：" +
                                                                    item.note
                                                                  : ""),
                                                              placement: "top",
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.category_name.slice(
                                                                    0,
                                                                    20
                                                                  )
                                                                ) + "..."
                                                              ),
                                                            ]),
                                                            item.status == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "#DF0A0A",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(隐藏)"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            item.use_range == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "tagType1",
                                                                  },
                                                                  [_vm._v("通")]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "tagType2",
                                                                  },
                                                                  [_vm._v("专")]
                                                                ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType3",
                                                              },
                                                              [_vm._v("促")]
                                                            ),
                                                          ]
                                                        )
                                                      : item.category_name
                                                          .length < 21 &&
                                                        item.note
                                                      ? _c(
                                                          "el-tooltip",
                                                          {
                                                            staticClass: "item",
                                                            attrs: {
                                                              effect: "dark",
                                                              content:
                                                                item.category_name +
                                                                (item.note
                                                                  ? "：" +
                                                                    item.note
                                                                  : ""),
                                                              placement: "top",
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.category_name
                                                                )
                                                              ),
                                                            ]),
                                                            item.status == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "#DF0A0A",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(隐藏)"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            item.use_range == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "tagType1",
                                                                  },
                                                                  [_vm._v("通")]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "tagType2",
                                                                  },
                                                                  [_vm._v("专")]
                                                                ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tagType3",
                                                              },
                                                              [_vm._v("促")]
                                                            ),
                                                          ]
                                                        )
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.category_name
                                                            )
                                                          ),
                                                        ]),
                                                    item.status == 1
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#DF0A0A",
                                                            },
                                                          },
                                                          [_vm._v("(隐藏)")]
                                                        )
                                                      : _vm._e(),
                                                    item.use_range == 1
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tagType1",
                                                          },
                                                          [_vm._v("通")]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tagType2",
                                                          },
                                                          [_vm._v("专")]
                                                        ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "tagType3",
                                                      },
                                                      [_vm._v("促")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e()
                      }
                    ),
                  ],
                  2
                ),
              ]),
              _c(
                "div",
                { staticClass: "drawer-footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmMenu },
                    },
                    [_vm._v("确定")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.menuDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "supplier__dialog",
          attrs: {
            title: "设置子菜单",
            visible: _vm.childMensDialog,
            width: "28%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.childMensDialog = $event
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.checkedChildIds,
                callback: function ($$v) {
                  _vm.checkedChildIds = $$v
                },
                expression: "checkedChildIds",
              },
            },
            [
              _c(
                "div",
                { staticClass: "checkbox__wrap" },
                _vm._l(_vm.childMenus, function (items, idx) {
                  return _c(
                    "el-checkbox",
                    { key: idx, attrs: { label: items.id } },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(items.custom_cat_name)),
                        items.status == 1
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("（隐藏）"),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer dialog-footer-style",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.childMensDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: [
                      "viewCakeChild",
                      "viewLvmamaChild",
                      "viewFoodChild",
                    ].includes(_vm.childMenuType),
                  },
                  on: { click: _vm.setCheckedMenu },
                },
                [_vm._v(" 确认 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "brand__dialog",
          attrs: {
            title: "特殊品牌",
            visible: _vm.brandDialog,
            width: "640px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.brandDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 注：勾选后将添加特殊品牌，佣金以特殊品牌佣金进行计算 "),
          ]),
          _c(
            "el-table",
            {
              ref: "brandTable",
              attrs: {
                data: _vm.dialogSpecialBrands,
                border: "",
                height: "400px",
                "header-cell-style": {
                  color: "#333333",
                  background: "#f1f1f1",
                },
              },
              on: {
                "select-all": _vm.handleSelectChange,
                select: _vm.handleSelectChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { prop: "id", width: "80px", label: "ID" },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand_name", label: "品牌" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer dialog-footer-style",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.brandDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmBrand } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "supplier__dialog",
          attrs: {
            title: "设置不支持的供应商",
            visible: _vm.supplierDialog,
            width: "40%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.supplierDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "400px", overflow: "auto" } },
            [
              _c("el-alert", {
                staticClass: "el-tips",
                attrs: {
                  title: "选择不支持的供应商，选择的供应商在商城端不会显示商品",
                  type: "error",
                  closable: false,
                  effect: "dark",
                },
              }),
              _vm._l(_vm.dialogSuppliers, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("el-alert", {
                      staticClass: "tips-bold",
                      attrs: {
                        title: item.menus_name,
                        type: "info",
                        closable: false,
                      },
                    }),
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: item.checkedIds,
                          callback: function ($$v) {
                            _vm.$set(item, "checkedIds", $$v)
                          },
                          expression: "item.checkedIds",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "checkbox__wrap" },
                          _vm._l(item.list, function (items, idx) {
                            return _c(
                              "el-checkbox",
                              {
                                key: idx,
                                attrs: { label: items.id },
                                on: {
                                  change: function ($event) {
                                    return _vm.checkboxChange(items)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(_vm._s(items.name)),
                                ]),
                              ]
                            )
                          }),
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer dialog-footer-style",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.supplierDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmSupplier },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "brand__dialog",
          attrs: {
            title: "不支持的品牌",
            visible: _vm.notBrandDialog,
            width: "640px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.notBrandDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _vm._v(" 品牌名称："),
              _c("el-input", {
                staticStyle: { width: "210px", margin: "5px 3px" },
                attrs: { placeholder: "请选择不支持的品牌" },
                model: {
                  value: _vm.searchBrand.brand_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchBrand, "brand_name", $$v)
                  },
                  expression: "searchBrand.brand_name",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    icon: "el-icon-search",
                  },
                  on: { click: _vm.handleSearchBrand },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.dialogNotBrands,
                border: "",
                height: "400px",
                "header-cell-style": {
                  color: "#333333",
                  background: "#f1f1f1",
                },
              },
              on: {
                "select-all": _vm.handleSelectNotBrand,
                select: _vm.handleSelectNotBrand,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { prop: "id", width: "80px", label: "ID" },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand_name", label: "品牌" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer dialog-footer-style",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.notBrandDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmNotBrandDialog },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "10px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next",
                  "page-size": 20,
                  total: _vm.pages.totalCount,
                },
                on: {
                  "current-change": function (res) {
                    return _vm.onChange(res, 1)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "cake__dialog",
          attrs: {
            top: "7vh",
            title: "设置品牌黑名单",
            visible: _vm.cakeDialog,
            width: "640px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cakeDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "checked__cake" }, [
                _c("div", { staticClass: "checked__margin" }, [
                  _vm._v(" 已选品牌 "),
                  _vm.checkedCakes.length
                    ? _c(
                        "span",
                        {
                          staticClass: "clear",
                          on: { click: _vm.clearChecked },
                        },
                        [_vm._v("清空已选")]
                      )
                    : _vm._e(),
                ]),
                _vm.checkedCakes.length
                  ? _c(
                      "div",
                      _vm._l(_vm.checkedCakes, function (item, index) {
                        return _c(
                          "el-button",
                          {
                            key: item.id,
                            staticStyle: { margin: "0 10px 10px 0" },
                            attrs: { type: "info", size: "small", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.delCheckedCake(index, "cake")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.dialogType == 3
                                    ? item.brand_name
                                    : item.name
                                ) +
                                " "
                            ),
                            _c("span", {
                              staticClass: "btn-icon el-icon-close",
                            }),
                          ]
                        )
                      }),
                      1
                    )
                  : _c("div", { staticClass: "empty__style" }, [
                      _vm._v("暂未选择品牌！"),
                    ]),
              ]),
              _c("div", { staticClass: "wait__margin" }, [_vm._v("待选品牌")]),
              _c(
                "div",
                [
                  _vm._v(" 品牌名称："),
                  _c("el-input", {
                    staticStyle: { width: "210px", margin: "5px 3px" },
                    attrs: { clearable: "", placeholder: "请选择不支持的品牌" },
                    model: {
                      value: _vm.searchBrand.brand_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchBrand, "brand_name", $$v)
                      },
                      expression: "searchBrand.brand_name",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.getCakeList },
                    },
                    [_vm._v("搜索")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "medium" },
                      on: { click: _vm.batchAddCake },
                    },
                    [_vm._v("批量添加")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    data: _vm.cakeList,
                    border: "",
                    height: "400px",
                    "header-cell-style": {
                      color: "#333333",
                      background: "#f1f1f1",
                    },
                  },
                  on: {
                    "select-all": _vm.handleSelectCake,
                    select: _vm.handleSelectCake,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      selectable: _vm.selectable,
                      width: "55",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: _vm.dialogType == 3 ? "id" : "brand_id",
                      width: "80px",
                      label: "ID",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: _vm.dialogType == 3 ? "brand_name" : "name",
                      label: "品牌",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    "margin-bottom": "10px",
                    "margin-top": "10px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager,sizes, jumper, next",
                      "page-sizes": [20, 2000],
                      "page-size": 20,
                      total: _vm.pages.totalCount,
                    },
                    on: {
                      "size-change": function (res) {
                        return _vm.sizeChange(res, 4)
                      },
                      "current-change": function (res) {
                        return _vm.onChange(res, 4)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "margin-top": "-25px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.cakeDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.canEditRule },
                  on: { click: _vm.setBlackCake },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "cake__dialog",
          attrs: {
            top: "7vh",
            title: "在线点单品牌黑名单",
            visible: _vm.onlineOrderDialog,
            width: "640px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.onlineOrderDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "checked__cake" }, [
            _c("div", { staticClass: "checked__margin" }, [
              _vm._v(" 已选品牌 "),
              _vm.checkedOnlineOrder.length
                ? _c(
                    "span",
                    { staticClass: "clear", on: { click: _vm.clearChecked } },
                    [_vm._v("清空已选")]
                  )
                : _vm._e(),
            ]),
            _vm.checkedOnlineOrder.length
              ? _c(
                  "div",
                  _vm._l(_vm.checkedOnlineOrder, function (item, index) {
                    return _c(
                      "el-button",
                      {
                        key: item.id,
                        staticStyle: { margin: "0 10px 10px 0" },
                        attrs: { type: "info", size: "small", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.delCheckedCake(index, "onlineOrder")
                          },
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(item.brand_name) + " "),
                        _c("span", { staticClass: "btn-icon el-icon-close" }),
                      ]
                    )
                  }),
                  1
                )
              : _c("div", { staticClass: "empty__style" }, [
                  _vm._v("暂未选择品牌！"),
                ]),
          ]),
          _c("div", { staticClass: "wait__margin" }, [_vm._v("待选品牌")]),
          _c(
            "div",
            [
              _vm._v(" 品牌名称："),
              _c("el-input", {
                staticStyle: { width: "210px", margin: "5px 3px" },
                attrs: { clearable: "", placeholder: "请选择不支持的品牌" },
                model: {
                  value: _vm.searchBrand.brand_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchBrand, "brand_name", $$v)
                  },
                  expression: "searchBrand.brand_name",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.getOnlineOrderList(1)
                    },
                  },
                },
                [_vm._v("搜索")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.batchAddOnlineOrder },
                },
                [_vm._v("批量添加")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "multipleOnlineOrder",
              attrs: {
                data: _vm.onlineOrderList,
                border: "",
                height: "400px",
                "header-cell-style": {
                  color: "#333333",
                  background: "#f1f1f1",
                },
              },
              on: { "selection-change": _vm.handleSelectOnlineorder },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  selectable: _vm.onlineOrderSelectable,
                  width: "55",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand_id", width: "80px", label: "ID" },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand_name", label: "品牌" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "right",
                "margin-bottom": "10px",
                "margin-top": "10px",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, jumper, next",
                  "page-size": 20,
                  total: _vm.pages.totalCount,
                },
                on: {
                  "current-change": function (res) {
                    return _vm.onChange(res, 7)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "margin-top": "-25px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.onlineOrderDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.canEditRule },
                  on: { click: _vm.setBlackOnlineOrder },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "cake__dialog",
          attrs: {
            top: "7vh",
            title: "北京线下蛋糕品牌黑名单",
            visible: _vm.movieZydDialog,
            width: "640px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.movieZydDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "checked__cake" }, [
            _c("div", { staticClass: "checked__margin" }, [
              _vm._v(" 已选品牌 "),
              _vm.checkedMovieZydList.length
                ? _c(
                    "span",
                    { staticClass: "clear", on: { click: _vm.clearChecked } },
                    [_vm._v("清空已选")]
                  )
                : _vm._e(),
            ]),
            _vm.checkedMovieZydList.length
              ? _c(
                  "div",
                  _vm._l(_vm.checkedMovieZydList, function (item, index) {
                    return _c(
                      "el-button",
                      {
                        key: index,
                        staticStyle: { margin: "0 10px 10px 0" },
                        attrs: { type: "info", size: "small", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.delCheckedMovieZyd(index)
                          },
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(item.name) + " "),
                        _c("span", { staticClass: "btn-icon el-icon-close" }),
                      ]
                    )
                  }),
                  1
                )
              : _c("div", { staticClass: "empty__style" }, [
                  _vm._v("暂未选择品牌！"),
                ]),
          ]),
          _c("div", { staticClass: "wait__margin" }, [_vm._v("待选品牌")]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.batchAddMovieZyd },
                },
                [_vm._v("批量添加")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "movieZydTable",
              attrs: {
                data: _vm.movieZydList,
                border: "",
                height: "400px",
                "header-cell-style": {
                  color: "#333333",
                  background: "#f1f1f1",
                },
              },
              on: { "selection-change": _vm.handleSelectMovieZyd },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  selectable: _vm.onlineMovieZydSelectTable,
                  width: "55",
                },
              }),
              _c("el-table-column", { attrs: { prop: "name", label: "品牌" } }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "margin-top": "-25px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.movieZydDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.canEditRule },
                  on: { click: _vm.setMovieZydBrands },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "brand__dialog",
          attrs: {
            title: "标签黑名单",
            visible: _vm.notTagDialog,
            width: "450px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.notTagDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _vm._v(" 标签名称："),
              _c("el-input", {
                staticStyle: { width: "210px", margin: "5px 3px" },
                attrs: { placeholder: "请选择不支持的品牌" },
                model: {
                  value: _vm.searchTags.tag_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchTags, "tag_name", $$v)
                  },
                  expression: "searchTags.tag_name",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    icon: "el-icon-search",
                  },
                  on: { click: _vm.handleSearchTag },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tagList,
                border: "",
                height: "400px",
                "header-cell-style": {
                  color: "#333333",
                  background: "#f1f1f1",
                },
              },
              on: {
                "select-all": _vm.handleSelectNotTags,
                select: _vm.handleSelectNotTags,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { prop: "tag_name", label: "标签" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer dialog-footer-style",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.notTagDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNotTags } },
                [_vm._v("添 加")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "right",
                "margin-top": "10px",
                "padding-bottom": "10px",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next",
                  "page-size": 20,
                  total: _vm.pages.totalCount,
                },
                on: {
                  "current-change": function (res) {
                    return _vm.onChange(res, 3)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "brand__dialog",
          attrs: {
            title: "设置利润率",
            visible: _vm.discountDialog,
            width: "340px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.discountDialog = $event
            },
            close: _vm.cancelDiscountDialog,
          },
        },
        [
          _vm.showDiscountTabs
            ? _c(
                "el-tabs",
                {
                  staticStyle: { margin: "-20px 0 20px 0" },
                  on: { "tab-click": _vm.handleClickDisCountTab },
                  model: {
                    value: _vm.discountTabsVal,
                    callback: function ($$v) {
                      _vm.discountTabsVal = $$v
                    },
                    expression: "discountTabsVal",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "蛋糕到店", name: "cake_store" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "蛋糕自由兑", name: "cake_store_zyd" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
              _vm._v(" 利润率："),
              _c("el-input", {
                staticStyle: { width: "210px", margin: "5px 3px" },
                model: {
                  value: _vm.commonDiscount,
                  callback: function ($$v) {
                    _vm.commonDiscount = $$v
                  },
                  expression: "commonDiscount",
                },
              }),
              _vm._v("% "),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { color: "#999999", "margin-top": "10px" } },
            [
              _vm._v(
                " 描述：利润率=1-结算价/售价，配置后仅显示该利润率及以上的电子券，仅影响显示不影响支付 "
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer dialog-footer-style",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelDiscountDialog } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.canEditRule },
                  on: {
                    click: function ($event) {
                      return _vm.setDiscount()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "配置积分价值",
            visible: _vm.integralDialog,
            "modal-append-to-body": false,
            "append-to-body": "",
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.integralDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "integralForm",
              staticClass: "form",
              attrs: { size: "small", model: _vm.integralForm },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否启用积分价值:",
                    prop: "is_open_integral_value",
                    rules: {
                      required: true,
                      message: "请选择首页模式",
                      trigger: "change",
                    },
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.integralForm.is_open_integral_value,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.integralForm,
                            "is_open_integral_value",
                            $$v
                          )
                        },
                        expression: "integralForm.is_open_integral_value",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "积分价值单位:",
                    prop: "integral_value_unit",
                    rules: [{ required: true, message: "请输入积分价值单位" }],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.integralForm.integral_value_unit,
                      callback: function ($$v) {
                        _vm.$set(_vm.integralForm, "integral_value_unit", $$v)
                      },
                      expression: "integralForm.integral_value_unit",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "积分价值比例:",
                    prop: "integral_value_rate",
                    rules: [
                      {
                        required: true,
                        trigger: "blur",
                        message: "请输入积分价值比例",
                      },
                      {
                        pattern: /^\d{1,9}(.\d{1,4})?$/,
                        message: "请填写数字格式，最多四位小数",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "220px" },
                      attrs: { placeholder: "请输入" },
                      model: {
                        value: _vm.integralForm.integral_value_rate,
                        callback: function ($$v) {
                          _vm.$set(_vm.integralForm, "integral_value_rate", $$v)
                        },
                        expression: "integralForm.integral_value_rate",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                  _c("span", { staticStyle: { color: "#67c23a" } }, [
                    _vm._v(
                      "100点= " +
                        _vm._s(_vm.toFixedRate) +
                        _vm._s(
                          _vm.integralForm.integral_value_unit
                            ? _vm.integralForm.integral_value_unit
                            : "积分"
                        )
                    ),
                  ]),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      " 例：配置[积分价值比例]为80%,表示售面值200的卡，积分价值菜单可使用金额为80%*200=160； "
                    ),
                  ]),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      " 例：配置[积分价值比例]为110%,表示售面值200的卡，积分价值菜单可使用金额为110%*200=220 "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.integralDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setIntegral } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置积分价值",
            visible: _vm.integralMenuDialog,
            "modal-append-to-body": false,
            "append-to-body": "",
            width: "350px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.integralMenuDialog = $event
            },
          },
        },
        [
          _vm._v(" 是否设置积分价值： "),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.menu_integral_value,
                callback: function ($$v) {
                  _vm.menu_integral_value = $$v
                },
                expression: "menu_integral_value",
              },
            },
            [
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.integralMenuDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.setIntegralMenu },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.currentRowMenu.type == "movie"
                ? "影厅关键词黑名单"
                : "关键词黑名单",
            visible: _vm.keywordBlackDialog,
            "append-to-body": "",
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.keywordBlackDialog = $event
            },
            close: function ($event) {
              _vm.keywordArr = []
            },
          },
        },
        [
          !["viewMovieKeyword", "viewLvmamaKeyword"].includes(_vm.childMenuType)
            ? [
                _c(
                  "div",
                  [
                    _vm._v(" 关键词 "),
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "text",
                        placeholder: "请输入内容",
                        maxlength: "10",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.keyword,
                        callback: function ($$v) {
                          _vm.keyword = $$v
                        },
                        expression: "keyword",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addBlackKeyword },
                      },
                      [_vm._v("添加到黑名单")]
                    ),
                  ],
                  1
                ),
                _c("br"),
                _c("div", [_vm._v("已添加：")]),
                _c("br"),
              ]
            : _vm._e(),
          _c(
            "div",
            _vm._l(_vm.keywordArr, function (item, index) {
              return _c(
                "el-button",
                {
                  key: index,
                  staticStyle: { margin: "0 5px 10px 0" },
                  attrs: { type: "info", size: "small", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.delBlackKeyword(index)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(item) + " "),
                  _c("span", { staticClass: "btn-icon el-icon-close" }),
                ]
              )
            }),
            1
          ),
          !["viewMovieKeyword", "viewLvmamaKeyword"].includes(_vm.childMenuType)
            ? _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.canEditRule },
                      on: { click: _vm.setBlackKeyword },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm.canEditRule && !["delivery", "log"].includes(_vm.configType)
        ? _c(
            "el-button",
            {
              staticStyle: { margin: "0 20px" },
              attrs: { loading: _vm.loading, type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitCardRule(1)
                },
              },
            },
            [_vm._v("确定")]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置显示/隐藏",
            visible: _vm.menuSwitchDialog,
            "modal-append-to-body": false,
            width: "350px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.menuSwitchDialog = $event
            },
          },
        },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.is_show,
                callback: function ($$v) {
                  _vm.is_show = $$v
                },
                expression: "is_show",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("显示")]),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("隐藏")]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "line-height": "15px",
                color: "#979494",
                "margin-top": "10px",
              },
            },
            [
              _c("div", [
                _vm._v(
                  " 说明：用户绑定卡的功能菜单均设置为隐藏时，功能菜单在C端分类中隐藏； "
                ),
              ]),
              _c("div", [_vm._v("例如：")]),
              _c("div", [
                _vm._v(
                  " 1.用户有A卡 、B卡，A卡中菜单1显示、B卡中菜单1隐藏，菜单1在分类中显示 "
                ),
              ]),
              _c("div", [
                _vm._v(
                  " 2.用户有A卡 、B卡，A卡中菜单1隐藏、B卡中菜单1隐藏，菜单1在分类中隐藏 "
                ),
              ]),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.menuSwitchDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.setMenuSwitch },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleBeforeClose,
            visible: _vm.whiteMovieDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.whiteMovieDialog = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("span", [_vm._v("设置白名单")]),
            _vm.queryData.order_id
              ? _c(
                  "span",
                  { staticStyle: { color: "red", "margin-left": "10px" } },
                  [_vm._v("订单号：" + _vm._s(_vm.queryData.order_id))]
                )
              : _vm._e(),
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _vm.movie_white_list_type == 2 && _vm.checkedCityList.length
              ? _c("div", [_vm._v(" 当前已设置【电影城市白名单】 ")])
              : _vm._e(),
            _vm.movie_white_list_type == 1 && _vm.whiteCinemaList.length
              ? _c("div", [_vm._v(" 当前已设置【电影影院白名单】 ")])
              : _vm._e(),
            _vm.movie_white_list_type == 0 ||
            (!_vm.checkedCityList.length && !_vm.whiteCinemaList.length)
              ? _c("div", [_vm._v(" 暂未设置白名单 ")])
              : _vm._e(),
          ]),
          _vm.childMenuType !== "viewWhiteMovie"
            ? _c(
                "div",
                { staticStyle: { margin: "10px 0" } },
                [
                  _vm._v(" 选择白名单类型 "),
                  _c(
                    "el-radio-group",
                    {
                      on: { input: _vm.movieTypeChange },
                      model: {
                        value: _vm.movie_white_list_type,
                        callback: function ($$v) {
                          _vm.movie_white_list_type = $$v
                        },
                        expression: "movie_white_list_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("电影城市白名单"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("电影影院白名单"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#a69c9c", "margin-left": "15px" },
                    },
                    [_vm._v("说明：设置白名单时仅能选择一种白名单进行设置！")]
                  ),
                  _vm.whiteCinemaList.length || _vm.checkedCityList.length
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "15px" },
                          attrs: { size: "small", type: "danger" },
                          on: { click: _vm.cancelWhiteMovie },
                        },
                        [_vm._v("取消设置")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.movie_white_list_type == 2
            ? _c(
                "div",
                [
                  _vm.childMenuType !== "viewWhiteMovie"
                    ? [
                        _c("span", [_vm._v("选择城市")]),
                        _c("el-cascader", {
                          staticStyle: { margin: "0 10px" },
                          attrs: {
                            options: _vm.tempCity,
                            props: {
                              checkStrictly: true,
                              emitPath: true,
                              multiple: true,
                            },
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.city,
                            callback: function ($$v) {
                              _vm.city = $$v
                            },
                            expression: "city",
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !_vm.canEditRule,
                              size: "mini",
                              type: "primary",
                            },
                            on: { click: _vm.addCheckedCity },
                          },
                          [_vm._v("添加")]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "red",
                              margin: "10px 20px",
                              "font-size": "16px",
                            },
                          },
                          [_vm._v("添加或移除后该规则直接生效！")]
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "el-table",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: {
                        border: "",
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        align: "center",
                        height: "350",
                        "empty-text": "暂未配置",
                        data: _vm.checkedCityList,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "省份",
                          width: "120px",
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.province
                                          ? scope.row.province
                                          : "--"
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          883148148
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "城市",
                          width: "120px",
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.city ? scope.row.city : "--"
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2076616340
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "区县",
                          width: "120px",
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.town ? scope.row.town : "--"
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2862594292
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        disabled:
                                          !_vm.canEditRule ||
                                          _vm.childMenuType ===
                                            "viewWhiteMovie",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delCheckedCity(
                                            scope.row.code
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("移除")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2224791671
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-top": "10px",
                        "padding-bottom": "10px",
                      },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "prev, pager, next",
                          "page-size": 20,
                          total: _vm.pages.totalCount,
                        },
                        on: {
                          "current-change": function (res) {
                            return _vm.onChange(res, 5)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm.movie_white_list_type == 1
            ? _c(
                "div",
                [
                  _vm.childMenuType !== "viewWhiteMovie"
                    ? [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "red",
                              "margin-bottom": "10px",
                              "font-size": "16px",
                            },
                          },
                          [_vm._v(" 添加或移除后该规则直接生效！ ")]
                        ),
                        _c(
                          "div",
                          [
                            _vm._v(" 选择城市： "),
                            _c("el-cascader", {
                              attrs: {
                                options: _vm.cityTree,
                                props: { checkStrictly: true, emitPath: true },
                                filterable: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.city_id,
                                callback: function ($$v) {
                                  _vm.city_id = $$v
                                },
                                expression: "city_id",
                              },
                            }),
                            _vm._v(" 影院： "),
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "请输入影院",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.cinema_name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "cinema_name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "searchForm.cinema_name",
                              },
                            }),
                            _vm._v(" 折扣： "),
                            _c("el-input", {
                              staticStyle: { width: "90px" },
                              attrs: { placeholder: "最低", clearable: "" },
                              model: {
                                value: _vm.searchForm.start_discount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "start_discount",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "searchForm.start_discount",
                              },
                            }),
                            _c("span", { staticClass: "split" }, [_vm._v("—")]),
                            _c("el-input", {
                              staticStyle: { width: "90px" },
                              attrs: { placeholder: "最高", clearable: "" },
                              model: {
                                value: _vm.searchForm.end_discount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "end_discount",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "searchForm.end_discount",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "medium" },
                                on: { click: _vm.searchCinema },
                              },
                              [_vm._v("搜索")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "medium",
                                  disabled: !_vm.canEditRule,
                                },
                                on: { click: _vm.openExportDialog },
                              },
                              [_vm._v("导入")]
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c("div", { staticClass: "cinema-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "left" },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              margin: "5px 0",
                              color: "black",
                              "font-size": "16px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" 备选影院 ")]
                        ),
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.cinemaList,
                              border: "",
                              "empty-text": "暂未配置电影影院白名单",
                              height: "400px",
                              "header-cell-style": {
                                color: "#333333",
                                background: "#f1f1f1",
                              },
                            },
                            on: {
                              "selection-change": function (res) {
                                return _vm.handleChangeCinema(res, 1)
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { type: "selection", width: "55" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "standard_id",
                                width: "80px",
                                label: "影院编码",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "province_name", label: "省市区" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.province_name) +
                                              "/" +
                                              _vm._s(scope.row.city_name) +
                                              "/" +
                                              _vm._s(scope.row.area_name) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3682051811
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "province_name",
                                width: "80px",
                                label: "折扣",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(scope.row.discount) + "折"
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3250384447
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "cinema_name", label: "影院名称" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.cinema_name) +
                                              " "
                                          ),
                                          scope.row.state == 0
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [_vm._v("下架")]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                242247763
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "right",
                              "margin-top": "10px",
                              "padding-bottom": "10px",
                            },
                          },
                          [
                            _c("el-pagination", {
                              attrs: {
                                background: "",
                                layout: "total, sizes, prev, pager, next",
                                "page-size": _vm.cinemaPage2.pagesize,
                                "page-sizes": [20, 50, 100, 200, 500],
                                total: _vm.pages2.totalCount,
                              },
                              on: {
                                "size-change": function (res) {
                                  return _vm.sizeChange(res, 2)
                                },
                                "current-change": function (res) {
                                  return _vm.onChange(res, 2)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "center" },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { margin: "0" },
                            attrs: {
                              type: "primary",
                              disabled:
                                !_vm.canEditRule ||
                                _vm.childMenuType === "viewWhiteMovie",
                              icon: "el-icon-arrow-right",
                              circle: "",
                            },
                            on: { click: _vm.addWhiteCinema },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "margin-left": "-5px",
                                },
                              },
                              [_vm._v("添加")]
                            ),
                          ]
                        ),
                        _vm.checkedWhiteCinema.length
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { margin: "0" },
                                attrs: {
                                  disabled:
                                    !_vm.canEditRule ||
                                    _vm.childMenuType === "viewWhiteMovie",
                                  type: "warning",
                                  icon: "el-icon-arrow-left",
                                  circle: "",
                                },
                                on: { click: _vm.delWhiteCinema },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "10px",
                                      "margin-left": "-5px",
                                    },
                                  },
                                  [_vm._v("移除")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              margin: "5px 0",
                              color: "red",
                              "font-size": "16px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" 已选影院 ")]
                        ),
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.whiteCinemaList,
                              border: "",
                              "empty-text": "暂未配置电影影院白名单",
                              height: "400px",
                              "header-cell-style": {
                                color: "#333333",
                                background: "#f1f1f1",
                              },
                            },
                            on: {
                              "selection-change": function (res) {
                                return _vm.handleChangeCinema(res, 2)
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { type: "selection", width: "55" },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "standard_id",
                                width: "80px",
                                label: "影院编码",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "province_name", label: "省市区" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.province_name) +
                                              "/" +
                                              _vm._s(scope.row.city_name) +
                                              "/" +
                                              _vm._s(scope.row.area_name) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3682051811
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                width: "80px",
                                prop: "province_name",
                                label: "折扣",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(scope.row.discount) + "折"
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3250384447
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "cinema_name", label: "影院名称" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.cinema_name) +
                                              " "
                                          ),
                                          scope.row.state == 0
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [_vm._v("下架")]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                242247763
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "right",
                              "margin-top": "10px",
                              "padding-bottom": "10px",
                            },
                          },
                          [
                            _c("el-pagination", {
                              attrs: {
                                background: "",
                                layout: "total, sizes, prev, pager, next",
                                "page-size": _vm.cinemaPage1.pagesize,
                                "page-sizes": [20, 50, 100, 200, 500],
                                total: _vm.pages1.totalCount,
                              },
                              on: {
                                "size-change": function (res) {
                                  return _vm.sizeChange(res, 1)
                                },
                                "current-change": function (res) {
                                  return _vm.onChange(res, 6)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "supplier__dialog",
          attrs: {
            title: "添加子菜单",
            visible: _vm.groupMenusDialog,
            width: "28%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.groupMenusDialog = $event
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.checkedGroupChildIds,
                callback: function ($$v) {
                  _vm.checkedGroupChildIds = $$v
                },
                expression: "checkedGroupChildIds",
              },
            },
            [
              _c(
                "div",
                { staticClass: "checkbox__wrap" },
                _vm._l(_vm.groupChildMenus, function (items, idx) {
                  return _c(
                    "el-checkbox",
                    {
                      key: idx,
                      attrs: { label: items.id },
                      on: {
                        change: function ($event) {
                          return _vm.changeGroupChildMenu(items)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(items.category_name)),
                        items.status == 1
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("（隐藏）"),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer dialog-footer-style",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.groupMenusDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.setCheckedGropChildMenu },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("copy-order-rule-dialog", {
        ref: "copyOrderRule",
        on: { refreshOrderRule: _vm.refreshOrderRule },
      }),
      _c("set-commission-type-dialog", {
        ref: "settlementType",
        on: { upSettlementTypeSuccess: _vm.upSettlementTypeSuccess },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.cakeStoreDrawer,
            title:
              {
                2:
                  "蛋糕到店&自由兑" +
                  (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                3: "蛋糕到家" + (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                4: "在线点单" + (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                6: "电影" + (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                7: "景区门票" + (_vm.cakeStoreType === "set" ? "设置" : "资源"),
              }[_vm.dialogType] || "品牌设置",
            "custom-class": "myDrawer",
            size: "80%",
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cakeStoreDrawer = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      {
                        2:
                          "蛋糕到店&自由兑" +
                          (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                        3:
                          "蛋糕到家" +
                          (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                        4:
                          "在线点单" +
                          (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                        6:
                          "电影" +
                          (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                        7:
                          "景区门票" +
                          (_vm.cakeStoreType === "set" ? "设置" : "资源"),
                      }[_vm.dialogType] || "品牌设置"
                    )
                  ),
                ]),
                _vm.order_id
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-weight": "400",
                          "margin-left": "10px",
                        },
                      },
                      [_vm._v("（ID:" + _vm._s(_vm.order_id) + "）")]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm.dialogType == 3
            ? _c("cakeConfig", {
                attrs: {
                  currentRowMenu: _vm.currentRowMenu,
                  order_id: _vm.order_id,
                  ruleType: _vm.ruleType,
                  ruleInfo: _vm.ruleInfo,
                  hasEditRule: _vm.canEditRule,
                  menuType: _vm.menuType,
                  entryType: _vm.entryType,
                  cakeType: _vm.cakeStoreType,
                  cakeWhiteTotal: _vm.checkedCityTotal,
                },
                on: {
                  setBlackCake: _vm.setBlackCake,
                  openWhiteCity: _vm.openWhiteCity,
                  setChildMenu: _vm.setChildMenu,
                },
              })
            : _vm.dialogType == 4
            ? _c("onlineOrderConfig", {
                ref: "onlineOrderConfig",
                attrs: {
                  currentRowMenu: _vm.currentRowMenu,
                  order_id: _vm.order_id,
                  ruleType: _vm.ruleType,
                  ruleInfo: _vm.ruleInfo,
                  hasEditRule: _vm.canEditRule,
                  menuType: _vm.menuType,
                  entryType: _vm.entryType,
                  foodType: _vm.cakeStoreType,
                  blackCityTotal: _vm.checkedCityTotal,
                },
                on: {
                  setBlackOnlineOrder: _vm.setBlackOnlineOrder,
                  openWhiteCity: _vm.openWhiteCity,
                  setChildMenu: _vm.setChildMenu,
                },
              })
            : _vm.dialogType == 6
            ? _c("movieConfig", {
                ref: "movieConfig",
                attrs: {
                  currentRowMenu: _vm.currentRowMenu,
                  order_id: _vm.order_id,
                  ruleType: _vm.ruleType,
                  ruleInfo: _vm.ruleInfo,
                  hasEditRule: _vm.canEditRule,
                  menuType: _vm.menuType,
                  entryType: _vm.entryType,
                  movieType: _vm.cakeStoreType,
                  movie_white_list_type: _vm.movie_white_list_type,
                  checkedCityTotal: _vm.checkedCityTotal,
                  whiteCinemaTotal: _vm.whiteCinemaTotal,
                },
                on: {
                  openMovieKeyword: _vm.openKeywordBlackDialog,
                  openWhiteMovie: _vm.openWhiteMovieCity,
                },
              })
            : _vm.dialogType == 7
            ? _c("lvmamaConfig", {
                ref: "lvmamaConfig",
                attrs: {
                  currentRowMenu: _vm.currentRowMenu,
                  order_id: _vm.order_id,
                  ruleType: _vm.ruleType,
                  ruleInfo: _vm.ruleInfo,
                  hasEditRule: _vm.canEditRule,
                  menuType: _vm.menuType,
                  entryType: _vm.entryType,
                  lvmamaType: _vm.cakeStoreType,
                },
                on: {
                  setChildMenu: _vm.setChildMenu,
                  openLvmamaKeyword: _vm.openKeywordBlackDialog,
                },
              })
            : _c("cakeStoreConfig", {
                attrs: {
                  currentRowMenu: _vm.currentRowMenu,
                  order_id: _vm.order_id,
                  ruleType: _vm.ruleType,
                  ruleInfo: _vm.ruleInfo,
                  hasEditRule: _vm.canEditRule,
                  menuType: _vm.menuType,
                  entryType: _vm.entryType,
                  cakeStoreType: _vm.cakeStoreType,
                },
                on: {
                  changeType: _vm.changeType,
                  setBlackCake: _vm.setBlackCake,
                  setDiscount: _vm.setDiscount,
                  _syncCustomerList: _vm.syncCustomerList,
                },
              }),
        ],
        2
      ),
      _c("GoodsVisibilityCheck", {
        attrs: {
          visible: _vm.goodsVisibilityVisible,
          order_id: _vm.order_id,
          category_id: _vm.goodsVisibilityCategoryId,
        },
        on: {
          "update:visible": function ($event) {
            _vm.goodsVisibilityVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("自组自选菜单")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }